import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import Hero from './sections/Hero';
import Story from './sections/Story';
import Game from './sections/Game';
import CTA from './sections/CTA';
import Store from './sections/Store';
import Footer from '../../components/footer/Footer';
import './Parselings.css';

const Parselings = () => {
  return (
    <>
    <Navbar />
    <div className="parselings-container">
        <Hero/>
        <CTA/>
        <Story/>
        <Game/>
        <Store/>
        <Footer/>
    </div>
    </>
  )
}

export default Parselings